import { ReduxAction, UserSession, UserSessionInitialState } from "../models";
import { UserSessionTypes } from "../types/user.session.types";

export const UserState = (state: UserSession = UserSessionInitialState, action?: ReduxAction): UserSession => {
    if (!action) return state;

    switch (action.type) {
        case UserSessionTypes.REQUEST_LOGIN_CODE:
        case UserSessionTypes.VERIFY_LOGIN_CODE:
        case UserSessionTypes.SHOW_USER_SESSION_LOADING:
        case UserSessionTypes.UPDATE_PROFILE:
        case UserSessionTypes.REMIND_PROFILE_COMPLETE_LATER:
            return { ...state, loading: true };
        case UserSessionTypes.HIDE_USER_SESSION_LOADING:
            return { ...state, loading: false };
        case UserSessionTypes.LOGIN_USER:
            return { ...state, loading: false, user: { ...state.user, ...action.payload }, loggedIn: state.loggedIn || !!action.payload.accessToken };
        case UserSessionTypes.LOGOUT_USER:
        case UserSessionTypes.CLEAR_LOGIN_INFO:
            return { ...state, user: undefined, loading: false, loggedIn: false };
        case UserSessionTypes.REQUEST_USER_INFO:
            return { ...state, fetching: true };
        case UserSessionTypes.SET_USER_INFO:
            return { ...state, fetching: false, user: { ...state.user, ...action.payload, accessToken: state.user?.accessToken, profilePromotion: action.payload.updateNotify ? null : action.payload.profilePromotion } };
        case UserSessionTypes.SEE_PWA_GUID:
            return { ...state, pwaSeen: true };
        case UserSessionTypes.UN_SEE_PWA_GUID:
            return { ...state, pwaSeen: false };
        case UserSessionTypes.HIDE_PACKAGE_BANNER:
            const now = new Date();
            const packageBannerReshowDate = new Date(now.setMonth(now.getMonth() + 1));
            return { ...state, packageBannerReshowDate };
    }

    return state;
};